var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iq-works-box text-left"},[_c('div',{staticClass:"step"},[_vm._v("\n    "+_vm._s(_vm.step)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"icon-bg text-center"},[_vm._t("cardMedia")],2),_vm._v(" "),_vm._t("cardBody")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }